import { GrCircleQuestion } from "react-icons/gr";
import { FormattedMessage } from "react-intl";
import Skeleton from "react-loading-skeleton";
import Tooltip from "../Tooltip/Tooltip";
import moment from "moment-timezone";
import { japanControllerCode } from "../../utils/constants";
import { useSelector } from "react-redux";
import { titleCase } from "../../utils/utils";
const getUtcOffset = (timeZone) => {
  if (!timeZone) return "UTC";
  try {
    const offset = moment.tz(timeZone).format("Z");
    return `UTC${offset}`;
  } catch (error) {
    return "N/A";
  }
};

const ConfigCard = ({ configDetails, loading }) => {
  const timeZone = configDetails?.data?.time_zone;
  const controllerCode = configDetails?.data?.controller_code;
  const controllerName = configDetails?.data?.controller_name;

  const showExactTimeZone = controllerCode === japanControllerCode;

  const utcOffset = showExactTimeZone ? timeZone : getUtcOffset(timeZone);
  const controllerConfig = useSelector(
    (state) => state.controllerConfig.controllerConfig,
  );
  return (
    <>
      {loading ? (
        <div className="pb-4">
          <Skeleton height={250} enableAnimation={true} />{" "}
        </div>
      ) : (
        <div
          className="container-fluid"
          style={{
            backgroundColor: "var(--theme-surface)",
            color: "var(--theme-text)",
            border: "1px solid var(--theme-border)",
            borderRadius: "8px",
            marginBottom: "2rem",
          }}
        >
          <div className="modal-body">
            <div
              style={{
                color: "var(--theme-accent)",
                fontWeight: "bold",
                padding: "15px 0 5px 0",
              }}
            >
              Controller Information
            </div>
            <div className="row align-items-center py-2">
              <div className="col-sm-4">
                <label className="fw-bold">
                  <FormattedMessage
                    id="label.controllername"
                    defaultMessage="Controller Name"
                  />
                </label>
                <div>{controllerName}</div>
              </div>
              <div className="col-sm-4">
                <label className="fw-bold">
                  <FormattedMessage
                    id="label.country-name"
                    defaultMessage="Country Name"
                  />
                </label>
                <div>
                  {controllerConfig?.country
                    ? `${controllerConfig?.country?.toUpperCase()} - ${titleCase(controllerConfig?.country_name||"")}`
                    : "N/A"}
                </div>
              </div>
              <div className="col-sm-4">
                <label className="fw-bold">
                  <FormattedMessage
                    id="label.marketidentifier"
                    defaultMessage="Market Identifier"
                  />
                </label>
                <div>{configDetails?.data?.market_identifier}</div>
              </div>
            </div>
            <div className="row align-items-center py-2">
              <div className="col-sm-4">
                <label className="fw-bold">
                  <FormattedMessage
                    id="label.lecode"
                    defaultMessage="Legal Entity Code"
                  />
                </label>
                <div>{configDetails?.data?.le_codes}</div>
              </div>
              <div className="col-sm-4">
                <label className="fw-bold d-flex gap-1">
                  <FormattedMessage
                    id="label.capturedatetimezone"
                    defaultMessage="Capture Date Time Zone"
                  />
                  <Tooltip
                    text="Time Zone setting used to calculate capture date and time for any manual processes (Bulk upload, Truman UI)"
                    type="configuration-capture-date-timezone"
                  >
                    <GrCircleQuestion className="table__date__icon"
                      size={19}
                    />
                  </Tooltip>
                </label>
                <div>
                  {utcOffset}
                </div>
              </div>
              <div className="col-sm-4">
                <label className="fw-bold">
                  <FormattedMessage
                    id="label.enablealias"
                    defaultMessage="Enable Alias"
                  />
                </label>
                <div>
                  {configDetails?.data?.enable_alias ? "True" : "False"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfigCard;
